import axios from 'axios';
import VueAxios from 'vue-axios';

import Vue from 'vue';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClock, faCheck, faPause, faPlay, faPlus, faMinus, faGripVertical, faArrowsAltV, faQuestionCircle, faGlobe, faArrowUp, faArrowDown, faImage, faLightbulb } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueClipboards from 'vue-clipboards';
import cytoscape from "cytoscape";
import layoutUtilities from "cytoscape-layout-utilities";
import VueMeta from 'vue-meta'
import VueResize from 'vue-resize'
import Transitions from 'vue2-transitions'
import App from './App.vue';
import router from './router';
import store from './store'
import Argon from "./plugins/argon-kit";
import i18n from './i18n'
import 'vue-resize/dist/vue-resize.css'
import Vue2Editor from "vue2-editor";

// Font Awesome
library.add(faClock);
library.add(faCheck);
library.add(faPause);
library.add(faPlay);
library.add(faMinus);
library.add(faPlus);
library.add(faGripVertical);
library.add(faArrowsAltV);
library.add(faQuestionCircle);
library.add(faGlobe);
library.add(faArrowDown);
library.add(faArrowUp);
library.add(faImage);
library.add(faLightbulb);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

cytoscape.use(layoutUtilities);

Vue.use(Vue2Editor);
Vue.use(VueAxios, axios);
Vue.use(Transitions)
Vue.use(BootstrapVue);
Vue.use(Argon)
Vue.use(VueClipboards);
Vue.use(VueMeta)
Vue.use(VueResize)

Vue.prototype.$bus = new Vue();

// Register a global custom directive called `v-focus`
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  store.dispatch("initializeAuthorization");

  window.scrollTo(0, 0);

  if (to.matched.some(record => record.meta.requiresGameCode)) {
    // If someone tries to go to an url without game code, throw to home page
    if (!store.state.main.game.gameCode) {
      next('/')
      return
    } else {
      next();
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/')
  } else {
    next();
  }
});

store.dispatch("startInterval")

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
